module.exports = __webpack_public_path__ + "img/team-dominik@2x.76a52b2f.jpg";